import { t } from "i18next";
import { TwentyIcCloseSmall } from "../icons/TwentyIcCloseSmall";
import "./Tag.css";

export interface TagProps {
  textOne?: string;
  textTwo?: string | string[];
  color?: string;
  resetAllFilterButton?: boolean;
  isRemoved?: (e: any) => any;
  isRem?: boolean;
}

const Tag: React.FC<TagProps> = ({
  textOne,
  textTwo,
  color,
  isRemoved,
  resetAllFilterButton,
  isRem = true,
}) => {
  const convertIfNumber = (val: string) => {
    const num = parseFloat(val);
    if (!isNaN(num)) {
      // Dividi per 0.8 e arrotonda a 2 decimali
      const converted = num / 0.8;
      return Math.round(converted * 100) / 100; // Arrotonda a 2 decimali
      // Oppure usa toFixed(2) se vuoi sempre 2 decimali:
      // return converted.toFixed(2);
    }
    return val;
  };

  // Converti textOne
  const displayTextOne = textOne ? convertIfNumber(textOne) : textOne;

  // Converti textTwo
  const displayTextTwo = textTwo
    ? Array.isArray(textTwo)
      ? textTwo.map((item) => convertIfNumber(item))
      : convertIfNumber(textTwo)
    : textTwo;

  return (
    <>
      {!resetAllFilterButton ? (
        textOne !== "" && textTwo !== "" ? (
          <div
            className="tag"
            style={{ backgroundColor: color ? color : "#ebf7f5" }}
          >
            <div className="tag-textone">
              {displayTextOne && displayTextOne}{" "}
            </div>
            <div className="tag-texttwo">
              {displayTextTwo && Array.isArray(displayTextTwo)
                ? displayTextTwo.map((e, index) =>
                    index === displayTextTwo.length - 1
                      ? e.toString() + " "
                      : e.toString() + ", "
                  )
                : displayTextTwo}
            </div>
            {isRem && (
              <>
                <span className="tag-divider" />
                <div onClick={isRemoved}>
                  <TwentyIcCloseSmall
                    color="#36b39e"
                    className="tag-icon"
                  ></TwentyIcCloseSmall>
                </div>
              </>
            )}
          </div>
        ) : null
      ) : (
        <div className="tag-reset" onClick={isRemoved}>
          <span className="tag-divider" />
          <div className="tag-text-reset">{t("smartPlan.common.resetAll")}</div>
          <span className="tag-divider" />
        </div>
      )}
    </>
  );
};

export default Tag;
